import { render, staticRenderFns } from "./ShareInform.vue?vue&type=template&id=8cadef24&scoped=true&"
import script from "./ShareInform.vue?vue&type=script&lang=js&"
export * from "./ShareInform.vue?vue&type=script&lang=js&"
import style0 from "./ShareInform.vue?vue&type=style&index=0&id=8cadef24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cadef24",
  null
  
)

export default component.exports